import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddTripDispatchDetails = ({ formRef, getData, tripId }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [tripOrders, setTripOrders] = useState([]);
  const [existFlag, setExistFlag] = useState(false);
  const [orderNumbers, setOrderNumbers] = useState([
    {
      dispatch_type: "",
      dispatch_id: "",
      unload_qty: 0,
      unload_destination: "",
      vehicle_reading: 0,
      remarks: "",
    },
  ]);
  const [product, setProduct] = useState(Array(orderNumbers.length).fill([]));
  const [yard, setYard] = useState(Array(orderNumbers.length).fill([]));
  const [rowAddData, setRowAddData] = useState({
    dispatch_type: "",
    dispatch_id: "",
    unload_qty: 0,
    unload_destination: "",
    vehicle_reading: 0,
    remarks: "",
    for_company_id: "",
    date: "",
  });

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const addOrderNumberRow = () => {
    setOrderNumbers([
      ...orderNumbers,
      {
        company_id: "",
        yard_id: "",
        product_name_id: "",
        dispatch_qty: "",
        p_damage_stock: 0,
        p_shortage_stock: 0,
        p_over_stock: 0,
      },
    ]);
    setSelectCompanyId(""); // Reset selectCompanyId to empty string
    setProductId(""); // Reset productId to empty string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const removeOrderNumberRow = (index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers.splice(index, 1);
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleCompanyChange = (e, index) => {
    setSelectCompanyId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].company_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
    singleYardDetails(e, index);
    getProductDetails(e, index);
  };

  function resetFields() {
    setRowAddData({
      dispatch_type: "",
      dispatch_id: "",
      unload_qty: 0,
      unload_destination: "",
      vehicle_reading: 0,
      remarks: "",
    });
    // setOrderId("");
    setProduct([]);
    setYardID("");
    setSelectCompanyId("");
    setProductId("");
    setClosingStockInYard("");
    setTripOrders([]);
    setOrderNumbers([
      {
        company_id: "",
        yard_id: "",
        product_name_id: "",
        dispatch_qty: "",
        p_damage_stock: 0,
        p_shortage_stock: 0,
        p_over_stock: 0,
      },
    ]);
    setVehicleNumber("");
    setTripOrders([]);
  }

  const handleVehicleChange = (e) => {
    setVehicleNumber(e.target.value);
  };

  const getProductDetails = async (e, index) => {
    const selectedCompanyId = e.target.value;
    const BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
      }),
    });
    const result = await res.json();
    // setProduct(result.data);
    if (res.ok) {
      const updatedProducts = [...product];
      updatedProducts[index] = result.data;
      setProduct(updatedProducts);
    } else {
      setProduct([]);
    }
  };

  const handleProductChange = (e, index) => {
    setProductId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].product_name_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const singleYardDetails = async (e, index) => {
    const selectedCompanyId = orderNumbers[index].company_id;
    const BASE_URL = `${SERVER_URL}/api/com-yard/single-company-yards/${user_id}/${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setYard(result.data);
      const updatedYards = [...yard];
      updatedYards[index] = result.data;
      setYard(updatedYards);
    } else {
      setYard([]);
    }
  };

  const getSingleYardDetailClosing = async () => {
    const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${productId}&yard_id=${yardId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setClosingStockInYard(result.data);
    } else {
      setClosingStockInYard("");
    }
  };

  const getTripExist = async () => {
    const BASE_URL = `${SERVER_URL}/api/trips-dispatch/trips-order-exist/${user_id}?trip_id=${tripId}&dispatch_type=${rowAddData?.dispatch_type}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTripOrders(result.data);
      setExistFlag(true);
    } else {
      setTripOrders([]);
      setExistFlag(false);
      toast.error(result.message);
    }
  };

  useEffect(() => {
    if (yardId) {
      getSingleYardDetailClosing();
    }
  }, [yardId, productId, selectCompanyId]);

  useEffect(() => {
    if (tripId && rowAddData.dispatch_type) {
      getTripExist();
    }
  }, [tripId, rowAddData.dispatch_type]);

  const handleYardChange = (e, index) => {
    setYardID(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].yard_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleQtyChange = (e, index, field) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index][field] = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log(orderNumbers);
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      dispatch_type,
      dispatch_id,
      unload_qty,
      unload_destination,
      vehicle_reading,
      remarks,
      for_company_id,
      date,
    } = rowAddData;
    if (!existFlag) {
      toast.error("Please check the existence of dispatch over order");
      return;
    }

    let BASE_URL = SERVER_URL + `/api/trips-dispatch/trips-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        dispatch_type,
        dispatch_id,
        unload_qty,
        unload_destination,
        vehicle_reading,
        remarks,
        trip_id: tripId,
        for_company_id,
        date,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="tripDetailsDispatchAdd"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="tripDetailsDispatchAddLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Trip Dispatch Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="dispatch_type">
                              Dispatch Type (Party)
                            </label>
                            <select
                              className="form-control form-control-lg"
                              value={rowAddData.dispatch_type}
                              onChange={handleChange}
                              name="dispatch_type"
                              id="dispatch_type"
                            >
                              <option value="">Select Dispatch Type</option>
                              <option value="govt">Government</option>
                              <option value="tkcs">TKCS</option>
                              <option value="private">Private</option>
                              <option value="material">Material</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="dispatch_id">
                              Order/Di Number or Party Name
                            </label>
                            <select
                              className="form-control form-control-lg"
                              value={rowAddData.dispatch_id}
                              onChange={handleChange}
                              name="dispatch_id"
                              disabled={
                                tripOrders && tripOrders?.length > 0
                                  ? false
                                  : true
                              }
                              id="dispatch_id"
                            >
                              <option value="">
                                Select Order/Di Number or Party Name
                              </option>
                              {tripOrders &&
                                tripOrders?.map((item, id) => (
                                  <option
                                    key={id}
                                    value={
                                      rowAddData?.dispatch_type === "material"
                                        ? item.material_name_id
                                        : item.id
                                    }
                                  >{`${
                                    item?.govtOrderNumber?.order_number ||
                                    item?.privateDiNumber?.di_number ||
                                    item?.privateLocalOrders?.party_name ||
                                    item?.party_name
                                  } | ${
                                    item?.rawMaterialName?.material_name ||
                                    item?.dispatch_details[0]?.size
                                  }`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        {rowAddData?.dispatch_type === "material" && (
                          <>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="company_id">Company Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  value={rowAddData.for_company_id || ""}
                                  onChange={handleChange}
                                  id="company_id"
                                  name="for_company_id"
                                >
                                  <option value="">Select Company</option>
                                  {company &&
                                    company.length > 0 &&
                                    company.map((item, id) => (
                                      <option key={id} value={item.id}>
                                        {`${item.company_name}, ${item.location}`}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label htmlFor="company_id">Date</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="date"
                                  id="unload_destination"
                                  placeholder="Unload Destination"
                                  onChange={handleChange}
                                  value={rowAddData.date}
                                  required
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                          </>
                        )}

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="unload_destination">
                              Unload Destination
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="unload_destination"
                                id="unload_destination"
                                placeholder="Unload Destination"
                                onChange={handleChange}
                                value={rowAddData.unload_destination}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="unload_qty">Unload Quantity</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="unload_qty"
                                id="unload_qty"
                                placeholder="Unload Quantity"
                                onChange={handleChange}
                                value={rowAddData.unload_qty}
                                required
                                autoComplete="off"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="vehicle_reading">
                              Vehicle Reading
                            </label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="vehicle_reading"
                                id="vehicle_reading"
                                placeholder="Vehilce Reading"
                                onChange={handleChange}
                                value={rowAddData.vehicle_reading}
                                required
                                autoComplete="off"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="remarks"
                                id="remarks"
                                placeholder="Remarks"
                                onChange={handleChange}
                                value={rowAddData.remarks}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {orderNumbers &&
                        orderNumbers?.length > 0 &&
                        orderNumbers?.map((order, index) => {
                          return (
                            <div key={index} className="row">
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="Company">Company Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.company_id}
                                    onChange={(e) =>
                                      handleCompanyChange(e, index)
                                    }
                                    id="Company"
                                  >
                                    <option value="">Select Company</option>
                                    {company &&
                                      company?.length > 0 &&
                                      company?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.company_name}, ${item.location}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="product">Product Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.product_name_id}
                                    onChange={(e) =>
                                      handleProductChange(e, index)
                                    }
                                    disabled={!selectCompanyId}
                                    id="product"
                                  >
                                    <option value="">Select Product</option>
                                    {product &&
                                      product[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.size}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="yard">Yard Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.yard_id}
                                    onChange={(e) => handleYardChange(e, index)}
                                    disabled={!selectCompanyId}
                                    id="yard"
                                  >
                                    <option value="">Select yard</option>
                                    {yard &&
                                      yard[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.yard_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="QTY">Dispatch Quantity</label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.dispatch_qty}
                                      name="dispatch_qty"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "dispatch_qty"
                                        )
                                      }
                                      required
                                      placeholder="Dispatch Quantity"
                                      id="QTY"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_damage_stock">
                                    Damage Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_damage_stock}
                                      name="p_damage_stock"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_damage_stock"
                                        )
                                      }
                                      required
                                      placeholder="Damage Quantity"
                                      id="p_damage_stock"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_shortage_stock">
                                    Shortage Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_shortage_stock}
                                      name="p_shortage_stock"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_shortage_stock"
                                        )
                                      }
                                      required
                                      placeholder="Shortage Quantity"
                                      id="p_shortage_stock"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_over_stock">
                                    Over Stock Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_over_stock}
                                      name="p_over_stock"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_over_stock"
                                        )
                                      }
                                      required
                                      placeholder="Over Stock/Goods Return Quantity"
                                      id="p_over_stock"
                                      min="0"
                                    />
                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        {index > 0 ? (
                                          <button
                                            type="button"
                                            title="Remove"
                                            className="btn btn-outline-danger btn-rounded btn-icon"
                                            onClick={() =>
                                              removeOrderNumberRow(index)
                                            }
                                          >
                                            <span className="mdi mdi-close-thick"></span>
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            disabled
                                            className="btn btn-outline-danger btn-rounded btn-icon"
                                          >
                                            <i className="mdi mdi-close" />
                                          </button>
                                        )}
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span> */}
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTripDispatchDetails;
